var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg90(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 15,
    viewBox: "0 0 32 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_284_27411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4609 9.96055H29.9909C30.3009 9.96055 30.5509 9.71055 30.5509 9.40055V5.62055C30.5509 5.31055 30.3009 5.06055 29.9909 5.06055H28.4609V9.97055V9.96055Z",
    fill: "#070A0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2 1C27.89 1 28.46 1.56 28.46 2.26V5.05H29.99C30.3 5.05 30.55 5.3 30.55 5.61V9.39C30.55 9.7 30.3 9.95 29.99 9.95H28.46V12.74C28.46 13.43 27.9 14 27.2 14H2.26C1.57 14 1 13.44 1 12.74V2.26C1 1.57 1.56 1 2.26 1H27.21M27.21 0H2.26C1.01 0 0 1.01 0 2.26V12.75C0 13.99 1.01 15.01 2.26 15.01H27.21C28.45 15.01 29.47 14 29.47 12.75V10.96H30C30.86 10.96 31.56 10.26 31.56 9.4V5.62C31.56 4.76 30.86 4.06 30 4.06H29.47V2.27C29.47 1.03 28.46 0.01 27.21 0.01V0Z",
    fill: "#070A0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.77047 2.18945H2.88047C2.52148 2.18945 2.23047 2.48047 2.23047 2.83945V12.1595C2.23047 12.5184 2.52148 12.8095 2.88047 12.8095H5.77047C6.12945 12.8095 6.42047 12.5184 6.42047 12.1595V2.83945C6.42047 2.48047 6.12945 2.18945 5.77047 2.18945Z",
    fill: "#0DD02C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9502 2.18945H8.06016C7.70117 2.18945 7.41016 2.48047 7.41016 2.83945V12.1595C7.41016 12.5184 7.70117 12.8095 8.06016 12.8095H10.9502C11.3091 12.8095 11.6002 12.5184 11.6002 12.1595V2.83945C11.6002 2.48047 11.3091 2.18945 10.9502 2.18945Z",
    fill: "#0DD02C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1396 2.18945H13.2496C12.8906 2.18945 12.5996 2.48047 12.5996 2.83945V12.1595C12.5996 12.5184 12.8906 12.8095 13.2496 12.8095H16.1396C16.4986 12.8095 16.7896 12.5184 16.7896 12.1595V2.83945C16.7896 2.48047 16.4986 2.18945 16.1396 2.18945Z",
    fill: "#0DD02C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3291 2.18945H18.4391C18.0801 2.18945 17.7891 2.48047 17.7891 2.83945V12.1595C17.7891 12.5184 18.0801 12.8095 18.4391 12.8095H21.3291C21.688 12.8095 21.9791 12.5184 21.9791 12.1595V2.83945C21.9791 2.48047 21.688 2.18945 21.3291 2.18945Z",
    fill: "#0DD02C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5107 2.18945H23.6207C23.2617 2.18945 22.9707 2.48047 22.9707 2.83945V12.1595C22.9707 12.5184 23.2617 12.8095 23.6207 12.8095H26.5107C26.8697 12.8095 27.1607 12.5184 27.1607 12.1595V2.83945C27.1607 2.48047 26.8697 2.18945 26.5107 2.18945Z",
    fill: "#0DD02C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_284_27411"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.55,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg90);
export default __webpack_public_path__ + "static/media/90.bfcd403433586650680e9743e7443be5.svg";
export { ForwardRef as ReactComponent };